import { CellTemplateContext, ColumnBuilder, DatasetTableAction, DatasetTableConfig, deleteAction, editAction, formattedColumn, numberColumn, TableConfigBuilder, textColumn } from "@ui";
import { VehicleGroupsModel } from "../../../../../../store/models/vehicle-groups.model";
import { TemplateRef } from "@angular/core";

export interface CreateVehicleGroupsTableConfigDependencies {
    onRowClick: (row: VehicleGroupsModel.VehicleGroupListDocument) => void;
    processingIds: () => string[];
    templates?: {
        sharedCell: TemplateRef<CellTemplateContext<VehicleGroupsModel.VehicleGroupListDocument>>;
    };
}

export function createVehicleGroupsTableConfig(
    dependencies: CreateVehicleGroupsTableConfigDependencies,
): DatasetTableConfig<VehicleGroupsModel.VehicleGroupListDocument> {
    const columnBuilder = new ColumnBuilder<VehicleGroupsModel.VehicleGroupListDocument>();
    
    const isProcessing = (row: VehicleGroupsModel.VehicleGroupListDocument): boolean =>
        new Set(dependencies.processingIds()).has(row._id);
    
    const isListAdminOnGroup = (row: VehicleGroupsModel.VehicleGroupListDocument): boolean =>
        row.activeOrgAccessRole === VehicleGroupsModel.ShareAccessRole.Admin;

    const shareWithLinkIcon: DatasetTableAction<VehicleGroupsModel.VehicleGroupListDocument> = {
        id: 'share',
        icon: 'ui-icon-link',
        iconType: 'ui-icon',
        label: 'COMMON.SHARE',
        tooltip: 'COMMON.SHARE',
        disabled: (row) => isProcessing(row),
        showInline: true,
    };

    const sharedColumn = dependencies.templates?.sharedCell
        ? columnBuilder
            .column('accessListCounter')
            .label('VEHICLE_GROUPS.TABLE.SHARED')
            .width('minmax(100px, 0.45fr)')
            .cellTemplate(dependencies.templates.sharedCell)
            .mobileVisible()
            .alignCenter()
            .build()
        : formattedColumn<VehicleGroupsModel.VehicleGroupListDocument>(
            'accessListCounter',
            'VEHICLE_GROUPS.TABLE.SHARED',
            () => '',
            {
                width: 'minmax(100px, 0.45fr)',
                mobileVisible: true,
                alignCenter: true,
            },
        );

    const tableBuilder = new TableConfigBuilder<VehicleGroupsModel.VehicleGroupListDocument>()
        .columns([
            textColumn<VehicleGroupsModel.VehicleGroupListDocument>('name', 'VEHICLE_GROUPS.TABLE.NAME', {
                width: 'minmax(200px, 1fr)',
                mobileVisible: true,
                cardMode: 'label-only',
            }),
            numberColumn<VehicleGroupsModel.VehicleGroupListDocument>('vehiclesCounter', 'VEHICLE_GROUPS.TABLE.USERS', {
                width: 'minmax(100px, 0.5fr)',
                mobileVisible: true,
                alignCenter: true,
                cardIcon: 'ui-icon-users',
            }),
            // sharedColumn,
        ])
        .actions([
            // shareWithLinkIcon,
            editAction<VehicleGroupsModel.VehicleGroupListDocument>({
                visible: (row) => isListAdminOnGroup(row),
                disabled: (row) => isProcessing(row),
            }),
            deleteAction<VehicleGroupsModel.VehicleGroupListDocument>({
                visible: (row) => isListAdminOnGroup(row),
                disabled: (row) => isProcessing(row),
            }),
        ])
        .actionsWidth(120)
        .rowHeight(52)
        .trackBy('_id');

    if (dependencies.onRowClick) {
        tableBuilder.onRowClick(dependencies.onRowClick);
    }

    return tableBuilder.build();
}
